import { REQUEST_ENTITY } from '../../../constants/entity'
import { ListItem } from '../../ListItem'
import { StatusListItemContent } from '../StatusListItemContent'

function StatusListItem({ entity = REQUEST_ENTITY, ...restProps }) {
  return (
    <ListItem {...restProps} Content={StatusListItemContent} entity={entity} />
  )
}

export default StatusListItem
